import React from "react";
import { Link } from "react-router-dom";
const CustomLink = ({ to, type, children, classes }) => {
  return (
    <Link
      className={`inline-block ${type === 'viewAll' ? 'view-all-link' : ''} ${classes || ''}`}
      to={to}
    >
      {children}
    </Link>
  );
};
export default CustomLink;